import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  session?: string;
}

export const Logo = ({ className, session }: LogoProps) => {
  const navigate = useNavigate();

  return (
    <img
      src="/logo/primary-cc-green.svg"
      alt="CauseConnect Logo"
      className={cn(
        "h-20 w-auto cursor-pointer transition-opacity hover:opacity-80",
        className
      )}
      onClick={() => navigate(session ? "/dashboard" : "/")}
      style={{ display: "inline-block" }}
    />
  );
};
